import React, { Component } from 'react'
import './App.css'
import format from './lib/dateFormat'
var createReactClass = require('create-react-class');

class App extends Component {
  constructor (props) {
    super(props)
    this.state = {
      value: '',
      dateValue: '',
      century: null,
      isDate: false
    }
  }

  componentDidMount () {
    var date = new Date()
    var dateValue = [ date.getDate(), date.getMonth() + 1, date.getFullYear() ].join('/')
    this.setState({
      dateValue: dateValue
    })
    this.handleDateChange({ target: { value: dateValue } })
  }

  handleChange (event) {
    console.log('changes', this)
    this.setState({ value: event.target.value })
    this.setState({ dateValue: '' })
    this.setState({ isDate: false })
  }

  handleDateChange (event) {
    console.log('changes', this)
    this.setState({ dateValue: event.target.value })
    var formattedDate = null
    var century = null
    var isDate = false
    try {
      var fullFormattedDate = format.date(event.target.value).split('-')
      formattedDate = fullFormattedDate[ 0 ]
      if (fullFormattedDate[ 1 ]) {
        century = fullFormattedDate[ 1 ].replace('C', '') || ''
      }
      isDate = true
    } catch (e) {
      console.log('failed to find date')
      formattedDate = event.target.value.replace(/[^0-9]/g, '')
    }
    this.setState({ isDate: isDate })
    this.setState({ value: formattedDate })
    this.setState({ century: century })
  }

  render () {
    return (
      <div className='App'>
        <div className='App-header'>
          {/*<img src={logo} className="App-logo" alt="logo"/>*/}
          <h2>PAO Test</h2>
        </div>
        <p/>
        <PaoText numbers={this.state.value} paoData={this.props.data} />
        <PaoImage numbers={this.state.value} paoData={this.props.data} />
        <br/>
        <input
          name='date'
          type='text'
          value={this.state.dateValue}
          onChange={this.handleDateChange.bind(this)} />
        <br/>
        <input
          autoFocus
          name='numbers'
          type='number'
          value={this.state.value}
          onChange={this.handleChange.bind(this)} />
        <br/>
        <IsDateText isDate={this.state.isDate} />
        <MajorText numbers={this.state.value} paoData={this.props.data} />
      </div>
    )
  }
}

var MajorText = createReactClass({
  render: function () {
    var numbers = format.numberSplit(this.props.numbers)
    var paoData = this.props.paoData
    return (
      <span id='majorText'>{numbers.map(function (e, i) {
                        if (isNaN(parseInt(e, 10))) {
                          return null
                        }
                        return <span className='majorSpan' key={i}><b>{format.getMajor(e)} - {e}</b> - {paoData[ e ][ 'PERSON' ] || paoData[ e ][ 'OBJECT' ]} <br/></span>
                      })}</span>
    )
  }
})

var IsDateText = createReactClass({
  render: function () {
    console.log('this.props.century', this.props.isDate)
    if (this.props.isDate) {
      return <span><i>is a date</i></span>
    }
    return null
  }
})

var PaoText = createReactClass({
  dumpResults: function (numbers, paoData) {
    var result = []
    format.numberSplit(numbers).forEach(function (e, i) {
      if (i % 3 === 0) {
        result.push(paoData[ e ][ 'PERSON' ], '(' + e + ')', '/')
      } else if (i % 3 === 1) {
        result.push(paoData[ e ][ 'ACTION' ], '(' + e + ')', '/')
      } else if (i % 3 === 2) {
        result.push(paoData[ e ][ 'OBJECT' ], '(' + e + ')', '<br/>')
      }
    })
    return result.join(' ').replace('<br/>, ', '<br/>')
  },
  createMarkup() {
    return { __html: this.dumpResults(this.props.numbers, this.props.paoData) }
  },
  render: function () {
    return (
      <div dangerouslySetInnerHTML={this.createMarkup()} />
    )
  }
})

var PaoImage = createReactClass({
  render: function () {
    var urlRoot = 'http://casual-hosting.s3-website-eu-west-1.amazonaws.com/image/'
    var numbers = format.numberSplit(this.props.numbers)
    console.log('this.props.numbers', numbers)
    var url = urlRoot + numbers[ 0 ] + '-1.jpg'
    var lineBreak = ''
    var suffix = ''

    return <span id='paoImage'>{numbers.map(function (e, i) {
                       if (isNaN(parseInt(e, 10))) {
                         return null
                       }

                       lineBreak = ''
                       suffix = '-1.jpg'

                       switch (i % 3) {
                         case 2:
                           lineBreak = <br/>
                           break
                         case 1:
                           suffix = '-2.jpg'
                           break
                         default:
                       }

                       url = urlRoot + e + suffix

                       return <span className='majorSpan' key={i}><a href={url}><img
                                                                                                                  width='100px'
                                                                                                                  src={url}
                                                                                                                  alt={e}
                                                                                                                  className='img-responsive' /> {lineBreak}</a></span>
                     })}</span>
  }
})

// http://casual-hosting.s3-website-eu-west-1.amazonaws.com/image/01-1.jpg

export default App



// WEBPACK FOOTER //
// ./src/App.js